

export class EmployeeGroupStatusOutput implements IEmployeeGroupStatusOutput {
    status!: number;
    message!: string;

    constructor(data?: IEmployeeGroupStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): EmployeeGroupStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data; 
    }
}

export interface IEmployeeGroupStatusOutput {
    status: number;
    message: string;
}

